import { useState, useRef } from 'react';
import Markdown from 'react-markdown'
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate, useParams} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    
    const Entries = [
        {
            slug: 'intro',
            name: "Intro",
            description: `
# Welcome to the Essay Side of my Site

This is where I write things that are actually of substance. Unlike the blog or other parts of my site, these writings have been well thought out, edited, and sent around to peers before publish. Have a look around and I hope you find something that makes you think.

Sincerely,

Xara
`,
            
        },
        
        
    ]
    
    const [photoIndex, setPhotoIndex] = useState(0);
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
        navigate(dir);
    };
    
    
    const listItems = Entries.map((Entry, index) =>
                                  <div key={index}>
                                  <MenuListItem style={{ whiteSpace: 'normal', height: 'auto' }} onClick={() => {setSelectedEntry(Entry); setPhotoIndex(0)}}>
                                    <Link to={`/essays/${Entry.slug}`}>{Entry.name}</Link> 
                                  </MenuListItem>
                                  <Separator />
                                  </div>
                                  );
    
    // Replace your useParams block and selectedEntry state with this:
    const { slug } = useParams();

    // Derive selected entry from URL slug, fallback to first entry
    const selectedEntry = Entries.find(i => i.slug === slug) ?? Entries[0];
  
                                
                                  
    return (
      
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "800px"}}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Comics & 2D Art</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/Backpage')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
            <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, display: 'flex', flexDirection: "column" }}>
                
            
              
              <div style={{ display: 'flex', flexDirection: 'row', flex: 1, overflow: 'hidden' }}>
                <ScrollView style={{ height: '100%', flex: 2 }}>
                  <MenuList style={{ display: 'flex', flexDirection: 'column' }}>
                    {listItems}
                  </MenuList>
                </ScrollView>
                <ScrollView style={{ height: '100%', flex: 5 }}>
                  <div style={{ padding: '1rem' }}>
                    <Markdown>
                      {selectedEntry.description}
                    </Markdown>
                  
                  </div>
                </ScrollView>
              </div>
                
              
              </Frame>

            
            
            
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
